import React, { Component } from "react";
import {
  MDBRow,
  MDBCol,
  MDBContainer,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBIcon,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";
import axios from "axios";
// import { RiResetLeftFill } from "react-icons/ri";
import MetaTags from "react-meta-tags";
import Text from "antd/lib/typography/Text";
import { admission } from "../ADMISSION";
import Swal from "sweetalert2";
export default class Insertpresent9 extends Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      modalnotupload: false,
      document_id: null,
      filedoc: null,
      filedoc_name: null,
      openinsdoc: false,
      ShowfileUpload: [],
      rows: [],
      filedocument: null,
    };
    this.openinsertdocument = this.openinsertdocument.bind(this);
    this.documentnotupload_open = this.documentnotupload_open.bind(this);
    this.documentnotupload_close = this.documentnotupload_close.bind(this);
    this.uploadnotdocument = this.uploadnotdocument.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    axios
      .get(admission + "/student/loadpresent/" + localStorage.getItem("ID_LOGIN"))
      .then((respone) => {
        respone.data = respone.data.filter(({ REGISTER_STATUS }) => !(REGISTER_STATUS === "11"));
        if (this._isMounted) {
          this.setState({ rows: respone.data[0] });
        }
      });

    axios
      .get(admission + "/student_insertpresent9/ShowfileUpload/" + localStorage.getItem("ID_LOGIN"))
      .then((res) => {
        if (this._isMounted && res.data.length !== 0) {
          this.setState({ ShowfileUpload: res.data });
        }
      });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleChange(event) {
    console.log(event);
    event.preventDefault();
    this.getBase64(event.target.files[0], (files) => {
      this.setState({ [event.target.name]: files });
      this.setState({ [event.target.name + "_name"]: event.target.files[0].name });
      this.setState({ filedocument: event.target.files[0] });
    });
  }

  getBase64(files, callback) {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(files);
  }

  handleSubmit(event) {
    event.preventDefault();

    const formData = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
    formData.append("UserID", localStorage.getItem("ID_LOGIN"));
    formData.append("typedocument", this.state.document_id);
    formData.append("REGISTER_ID", this.state.rows.REGISTER_ID);
    formData.append("file", this.state.filedocument);

    axios.post(admission + "/student_insertpresent9/fileUpload/", formData).then((data) => {
      axios
        .get(
          admission + "/student_insertpresent9/ShowfileUpload/" + localStorage.getItem("ID_LOGIN")
        )
        .then((res) => {
          if (res.data.length !== 0) {
            this.setState({ ShowfileUpload: res.data });
          }
        });
      this.setState({ filedoc: null });
      this.setState({ filedoc_name: null });
      this.setState({ document_id: null });
      this.setState({ openinsdoc: false });
    });
  }

  openinsertdocument(event) {
    event.preventDefault();
    this.setState({ filedoc: null });
    this.setState({ filedoc_name: null });
    this.setState({ document_id: event.target.value });
    this.setState({ openinsdoc: true });
  }

  documentnotupload_open(event) {
    event.preventDefault();
    this.setState({ modalnotupload: true });
  }

  documentnotupload_close(event) {
    if (event && event.preventDefault) {
      event.preventDefault();
    }
    this.setState({ modalnotupload: false });
  }

  uploadnotdocument(event) {
    if (event && event.preventDefault) {
      event.preventDefault();
    }
    if (this._isMounted) {
      // ปิด modal ก่อน เพื่อลดโอกาสชน DOM ตอนมี re-render ตาราง
      this.setState({ modalnotupload: false });
    }
    // axios.get("https://git.kpru.ac.th/admission2017/student_insertpresent9/UploadnotDocument/"+localStorage.getItem("ID_LOGIN")+"/5").then((res) => {
    axios
      .get(
        admission +
          "/student_insertpresent9/UploadnotDocument/" +
          localStorage.getItem("ID_LOGIN") +
          "/5"
      )
      .then((res) => {
        console.log(res.data);

        if (res.data.success === 1) {
          // เลี่ยง setState ซ้อนระหว่าง modal transition ที่อาจทำให้ DOMException
          window.location.reload();
        }
      });
  }

  render() {
    return (
      <>
        <MetaTags>
          <title>ข้อมูลไฟล์เอกสารประกอบการรายงานตัว มหาวิทยาลัยราชภัฏกำแพงเพชร</title>
          <meta
            name="description"
            content="ข้อมูลไฟล์เอกสารประกอบการรายงานตัว มหาวิทยาลัยราชภัฏกำแพงเพชร Kamphaeng Phet Rajabhat University"
          />
          <meta
            property="og:title"
            content="ข้อมูลไฟล์เอกสารประกอบการรายงานตัว มหาวิทยาลัยราชภัฏกำแพงเพชร"
          />
          <meta property="og:image" content="../../public/favicon.ico" />
        </MetaTags>
        <br />
        <MDBContainer fluid>
          <h4>ข้อมูลรายงานตัว มหาวิทยาลัยราชภัฏกำแพงเพชร</h4>

          <MDBRow>
            <MDBCol lg="1" md="0" sm="0"></MDBCol>
            <MDBCol lg="10" md="12" sm="12">
              <MDBCard>
                <MDBCardBody>
                  <MDBContainer fluid>
                    <MDBRow>
                      <MDBCol>
                        <MDBCardTitle>ข้อมูลไฟล์เอกสารประกอบการรายงานตัว</MDBCardTitle>
                        <MDBCardText>
                          <span className="text-danger">
                            *
                            หลักฐานสำเนาที่อัพโหลดเข้าระบบต้องสำเนาถูกต้องและลงลายมือชื่อให้เรียบร้อย
                          </span>
                          <br />
                          <span className="text-danger">* ใช้เป็นไฟล์นามสกุล PDF เท่านั้น</span>
                          <MDBRow>
                            <MDBCol lg="12" md="12" sm="12">
                              {this.state.openinsdoc ? (
                                <>
                                  <MDBCard>
                                    <MDBCardBody>
                                      <MDBCardTitle>
                                        <h5>ข้อมูลเอกสารประกอบรายงานตัว</h5>
                                      </MDBCardTitle>
                                      <MDBCardText>
                                        <form onSubmit={this.handleSubmit}>
                                          <div className="form-outline">
                                            <label className="form-label" for="filedoc">
                                              ไฟล์เอกสาร <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <br />
                                            <label
                                              for="filedoc"
                                              className="custom-file-upload btn-block text-center"
                                            >
                                              <i className="fa fa-cloud-upload"></i>{" "}
                                              เลือกไฟล์ที่ต้องการ *.pdf
                                            </label>
                                            <input
                                              type="file"
                                              className="form-control"
                                              id="filedoc"
                                              name="filedoc"
                                              accept="application/pdf"
                                              onChange={this.handleChange}
                                              required
                                            />{" "}
                                            <br />
                                            {this.state.filedoc_name !== null ? (
                                              <>
                                                <span>{this.state.filedoc_name}</span>
                                                <br />
                                              </>
                                            ) : (
                                              <></>
                                            )}
                                            <span>รองรับไฟล์นามสกุล *.PDF เท่านั้น</span>
                                          </div>
                                          {this.state.filedoc_name !== null ? (
                                            <>
                                              <button
                                                type="submit"
                                                className="btn btn-primary btn-rounded btn-md mt-2"
                                              >
                                                บันทึกข้อมูล
                                              </button>
                                            </>
                                          ) : (
                                            <>
                                              <button
                                                type="submit"
                                                className="btn btn-primary btn-rounded btn-md mt-2"
                                                disabled
                                              >
                                                บันทึกข้อมูล
                                              </button>
                                            </>
                                          )}
                                        </form>
                                      </MDBCardText>
                                    </MDBCardBody>
                                  </MDBCard>
                                </>
                              ) : (
                                <></>
                              )}

                              <table className="table table-hover">
                                <thead>
                                  <tr className="table-info">
                                    <th>#</th>
                                    <th>เอกสารประกอบการรายงานตัว</th>
                                    <th>ไฟล์</th>
                                    <th>สถานะการตรวจสอบ</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.ShowfileUpload.map((data, index) => {
                                    return (
                                      <tr key={`${data.DOCUMENT_TYPE_ID || "doc"}-${index}`}>
                                        <td>{index + 1}</td>
                                        <td>
                                          {data.DOCUMENT_TYPE_NAME}
                                          {
                                            data.DOCUMENT_TYPE_NAME === "สำเนาใบเปลี่ยนชื่อ-นามสกุล" ? (
                                              <>
                                                <p style={{ fontSize: "14px", color: "red" }}>(เฉพาะชื่อหรือนามสกุลในบัตรประชาชนไม่ตรงกับใบแสดงผลการเรียน)</p>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          }
                                          
                                        </td>
                                        <td>
                                          {this.state.rows["MOJOR_ID"] === "9902" &&
                                          data.DOCUMENT_TYPE_ID === "4" ? (
                                            <>
                                              <a
                                                href="https://admission.kpru.ac.th/admission2017/public/Files_All/rubrongnurse.pdf"
                                                target="_blank"
                                                className="btn btn-success btn-md"
                                                role="button"
                                              >
                                                ดาวน์โหลดเอกสาร
                                              </a>
                                            </>
                                          ) : (
                                            <></>
                                          )}
                                          {data.FilesStatus === "2" ? (
                                            <></>
                                          ) : (
                                            <>
                                              {data.NumFile === "1" ? (
                                                <>
                                                  <a
                                                    href={
                                                      "https://admission.kpru.ac.th/admission2017/" +
                                                      data.Files
                                                    }
                                                    target="_blank"
                                                    className="btn btn-success btn-md"
                                                    role="button"
                                                  >
                                                    ดูไฟล์เอกสารแนบ
                                                  </a>
                                                  {/* <a href={"https://mua.kpru.ac.th/FrontEnd_Admission/" + data.Files} target="_blank" className="btn btn-success btn-md" role="button">ดูไฟล์เอกสารแนบ</a> */}
                                                </>
                                              ) : (
                                                <></>
                                              )}
                                              {data.NumFile === "1" && data.FilesStatus !== "1" ? (
                                                <>
                                                  <button
                                                    type="button"
                                                    className="btn btn-warning btn-md"
                                                    value={data.DOCUMENT_TYPE_ID}
                                                    onClick={this.openinsertdocument}
                                                  >
                                                    แก้ไขไฟล์เอกสาร
                                                  </button>
                                                </>
                                              ) : (
                                                <></>
                                              )}
                                              {data.NumFile === "1" && data.FilesStatus === "1" ? (
                                                <>
                                                  <button
                                                    type="button"
                                                    className="btn btn-warning btn-md"
                                                    disabled
                                                  >
                                                    แก้ไขไฟล์เอกสาร
                                                  </button>
                                                </>
                                              ) : (
                                                <></>
                                              )}
                                              {data.NumFile !== "1" ? (
                                                <>
                                                  {data.DOCUMENT_TYPE_ID === "5" ? (
                                                    <>
                                                      <button
                                                        type="button"
                                                        className="btn btn-info btn-md"
                                                        value={data.DOCUMENT_TYPE_ID}
                                                        onClick={this.openinsertdocument}
                                                      >
                                                        มี
                                                      </button>
                                                      <button
                                                        type="button"
                                                        className="btn btn-danger btn-md"
                                                        value={data.DOCUMENT_TYPE_ID}
                                                        onClick={this.documentnotupload_open}
                                                      >
                                                        ไม่มี
                                                      </button>
                                                    </>
                                                  ) : (
                                                    <>
                                                      <button
                                                        type="button"
                                                        className="btn btn-info btn-md"
                                                        value={data.DOCUMENT_TYPE_ID}
                                                        onClick={this.openinsertdocument}
                                                      >
                                                        แนบไฟล์เอกสาร
                                                      </button>
                                                    </>
                                                  )}
                                                </>
                                              ) : (
                                                <></>
                                              )}
                                            </>
                                          )}
                                        </td>
                                        <td>
                                          {data.Files !== null ? (
                                            <>
                                              {data.FilesStatus === "1" ? (
                                                <>
                                                  <span className="text-success">
                                                    <MDBIcon icon="check" /> ผ่านการตรวจสอบ
                                                  </span>
                                                </>
                                              ) : (
                                                <>
                                                  {data.FilesStatus === "0" ? (
                                                    <>
                                                      <span className="text-danger">
                                                        <MDBIcon icon="times" />{" "}
                                                        ไม่ผ่านการตรวจสอบเนื่องจาก{" "}
                                                        {data.FilesDetail}
                                                      </span>
                                                    </>
                                                  ) : (
                                                    <>
                                                      {data.FilesStatus === null ? (
                                                        <>
                                                          <span className="text-warning">
                                                            <MDBIcon icon="sync-alt" />{" "}
                                                            อยู่ระหว่างการตรวจสอบ
                                                          </span>
                                                        </>
                                                      ) : (
                                                        <></>
                                                      )}
                                                    </>
                                                  )}
                                                </>
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {data.FilesStatus === "2" ? (
                                                <>
                                                  <span className="text-danger">ไม่มีเอกสาร</span>
                                                  <div
                                                    className="btn btn-warning btn-sm ml-3"
                                                    onClick={() => {
                                                      // alert(localStorage.getItem("ID_LOGIN"))
                                                      axios
                                                        .post(
                                                          admission +
                                                            "/student_insertpresent9/CancelFileChangeName",
                                                          {
                                                            ID_LOGIN:
                                                              localStorage.getItem("ID_LOGIN"),
                                                          }
                                                        )
                                                        .then((res) => {
                                                          if (res.data === "success") {
                                                            Swal.fire({
                                                              icon: "success",
                                                              title: "รีเซ็ตรายการสำเร็จ",
                                                              timer: 1200,
                                                              timerProgressBar: true,
                                                            }).then((da) => {
                                                              window.location.reload();
                                                            });
                                                          }
                                                        });
                                                    }}
                                                  >
                                                    <MDBIcon icon="sync-alt" /> รีเซ็ต
                                                  </div>
                                                </>
                                              ) : (
                                                <>
                                                  <span className="black-text">
                                                    <MDBIcon icon="file-upload" />{" "}
                                                    ยังไม่ได้อัพโหลดเอกสาร
                                                  </span>
                                                  {/* <div
                                                    className="btn btn-warning btn-sm ml-3"
                                                    onClick={() => {
                                                      // alert(localStorage.getItem("ID_LOGIN"))
                                                      axios
                                                        .post(
                                                          admission +
                                                            "/student_insertpresent9/CancelFileChangeName",
                                                          {
                                                            ID_LOGIN:
                                                              localStorage.getItem("ID_LOGIN"),
                                                          }
                                                        )
                                                        .then((res) => {
                                                          if (res.data === "success") {
                                                            Swal.fire({
                                                              icon: "success",
                                                              title: "รีเซ็ตรายการสำเร็จ",
                                                              timer: 1200,
                                                              timerProgressBar: true,
                                                            }).then((da) => {
                                                              window.location.reload();
                                                            });
                                                          }
                                                        });
                                                    }}
                                                  >
                                                    <MDBIcon icon="sync-alt" /> รีเซ็ต
                                                  </div> */}
                                                </>
                                              )}
                                            </>
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>

                              {this.state.rows.LEVEL_OPEN_ID !== "4" &&
                              this.state.rows.LEVEL_OPEN_ID !== "19" ? (
                                <>
                                  <a
                                    href={`${process.env.REACT_APP_BASENAME || ""}/Present`}
                                    className="btn btn-success btn-block"
                                    role="button"
                                  >
                                    คลิกเพื่อกลับหน้าหลักเพื่อพิมพ์ใบรายงานตัว
                                  </a>
                                </>
                              ) : (
                                <></>
                              )}
                              {this.state.rows.LEVEL_OPEN_ID === "4" ||
                              this.state.rows.LEVEL_OPEN_ID === "19" ? (
                                <>
                                  <a
                                    href={`${process.env.REACT_APP_BASENAME || ""}/Insertpresent10`}
                                    className="btn btn-success btn-block"
                                    role="button"
                                  >
                                    คลิกเพื่ออัพโหลดข้อมูลผลคะแนน PAT 5
                                  </a>
                                </>
                              ) : (
                                <></>
                              )}
                            </MDBCol>
                          </MDBRow>
                        </MDBCardText>
                      </MDBCol>
                    </MDBRow>
                  </MDBContainer>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
            <MDBCol lg="1" md="0" sm="0"></MDBCol>
          </MDBRow>

          <MDBModal
            className="mb-5"
            size="lg"
            isOpen={this.state.modalnotupload}
            centered
            dark
          >
            <MDBModalHeader>
              <Text strong style={{ fontSize: "24px" }}>
                {" "}
                ยืนยันไม่มีเอกสาร{" "}
              </Text>
            </MDBModalHeader>
            <MDBModalBody>ข้าพเจ้าขอยืนยันไม่มีสำเนาเอกสารการเปลี่ยนชื่อ-นามสกุลจริง</MDBModalBody>
            <MDBModalFooter>
              <button
                type="button"
                className="mt-1 btn btn-md btn-success"
                onClick={this.uploadnotdocument}
              >
                ยืนยัน
              </button>
              <button
                type="button"
                className="mt-1 btn btn-md btn-danger"
                onClick={this.documentnotupload_close}
              >
                ปิด
              </button>
            </MDBModalFooter>
          </MDBModal>
        </MDBContainer>
      </>
    );
  }
}


